import {useData} from "vike-react/useData";
import {ApiAdBanner, ApiBlogPostData} from "#/src/definitions/ApiDefinitions";
import {WorthSeeArticle} from "#/src/pages/blog/@id/WorthSeeArticle";
import {RelatedArticles} from "#/src/pages/blog/@id/RelatedArticles";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import {Comments} from "#/src/pages/blog/@id/Comments";
import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext, DataWrapped} from "#/src/definitions/AppDefinitions";
import {ArticleAuthor} from "#/src/pages/blog/@id/ArticleAuthor";
import DOMPurify from "isomorphic-dompurify";
import styled from "@emotion/styled";
import {AdWrapper} from "#/src/components/AdWrapper";
import {Adsense} from "@ctrl/react-adsense";
import AppConstants from "#/src/utils/app-constants";

const ArticleAd = styled.img`
    max-width: 600px;
    width: 100%;
    height: auto;
`;

export function Content() {
  const {user} = usePageContext() as AppPageContext;
  const {data: postData} = useData() as DataWrapped<ApiBlogPostData>;

  function onFacebookShare() {
    const link = window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, "_blank", "noreferrer noopener");
    link.opener = null;
  }

  function onTwitterShare() {
    const link = window.open(`https://x.com/intent/tweet?url=${window.location.href}`, "_blank", "noreferrer noopener");
    link.opener = null;
  }

  function renderArticle() {
    const split = postData.article.description.includes("%| warto-sprawdzic |%");
    const mode = user.lightMode ? "LIGHT" : "DARK";
    const ad = postData.adData.find((adData: ApiAdBanner) => adData.placement == "ARTICLE" && adData.theme == mode);

    function renderAd() {
      if (!ad) {
        return <div className="col-xl-4 px-0">
          <div className="sidebar-sticky">
            <Adsense client={AppConstants.ADSENSE_CLIENT_ID} slot={"1647097545"} className={"campaign-banner type-300x600-adsense"} data-banner-id={"adsense-article"}/>
          </div>
        </div>
      }
      return <div className="col-xl-4">
        <div className="sidebar-sticky">
          <AdWrapper ad={ad} className={"campaign-banner type-300x600"}>
            <span className="text-white">
              <ArticleAd alt={ad.alt} src={Attachments.getUrl(AttachmentNamespace.AD, ad)}/>
             </span>
          </AdWrapper>
        </div>
      </div>
    }

    if (!split) {
      return <section className="article-wrapper">
        <div className="container-xxl">
          <div className="row">
            <div className={`col-xl-8`}>
              <div className="article-post" dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(postData.article.description, {
                  ADD_TAGS: ["iframe"],
                  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling']
                })
              }}></div>
            </div>
            {renderAd()}
          </div>
        </div>
      </section>
    }
    const splitData = postData.article.description.split("%| warto-sprawdzic |%");
    return <>
      <section className="article-wrapper">
        <div className="container-xxl">
          <div className="row">
            <div className={`col-xl-8`}>
              <div className="article-post" dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(splitData[0], {
                  ADD_TAGS: ["iframe"],
                  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling']
                })
              }}></div>
            </div>
            {renderAd()}
            {renderWorthSee()}
            <div className={`col-xl-8`}>
              <div className="article-post" dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(splitData[1], {
                  ADD_TAGS: ["iframe"],
                  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling']
                })
              }}></div>
            </div>
            {renderAd()}
          </div>
        </div>
      </section>
    </>
  }

  function renderWorthSee() {
    return <section className="news-short my-4">
      <div className="container-xxl border-space py-5">
        <h6 className="mb-4 title-small-uppercase">Warto sprawdzić</h6>
        <div className="row">
          {postData.hotArticles.map((article) => <WorthSeeArticle key={article.id} article={article}/>)}
        </div>
      </div>
    </section>
  }

  return <main>
    {renderArticle()}
    <section className="article-summary">
      <div className="container-xxl">
        <div className="col-xl-8">
          <div className="article-share">
            <span>Podobał Ci się artykuł? Podziel się z innymi:</span>
            <div className="btn-flex">
              <div onClick={onFacebookShare} className="btn share-fb me-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="#fff" d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4z"/>
                </svg>
                Facebook
              </div>
              <div onClick={onTwitterShare} className="btn share-twitter ms-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                  <path fill="#fff"
                        d="M9.294 6.928L14.357 1h-1.2L8.762 6.147L5.25 1H1.2l5.31 7.784L1.2 15h1.2l4.642-5.436L10.751 15h4.05zM7.651 8.852l-.538-.775L2.832 1.91h1.843l3.454 4.977l.538.775l4.491 6.47h-1.843z"/>
                </svg>
                Tweetuj
              </div>
            </div>
          </div>
          <ArticleAuthor/>
        </div>
      </div>
    </section>

    <Comments/>
    <RelatedArticles/>
  </main>
}